/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An access entry (lockbox, gate code, etc.) for a listing.
 * @export
 * @interface AccessEntry
 */
export interface AccessEntry {
    /**
     * 
     * @type {string}
     * @memberof AccessEntry
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessEntry
     */
    entryMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessEntry
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessEntry
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessEntry
     */
    note?: string;
}

/**
 * Check if a given object implements the AccessEntry interface.
 */
export function instanceOfAccessEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccessEntryFromJSON(json: any): AccessEntry {
    return AccessEntryFromJSONTyped(json, false);
}

export function AccessEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'entryMethod': !exists(json, 'entry_method') ? undefined : json['entry_method'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function AccessEntryToJSON(value?: AccessEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'entry_method': value.entryMethod,
        'location': value.location,
        'code': value.code,
        'note': value.note,
    };
}

